<template>
  <div>
    <v-img
      :aspect-ratio="16 / 9"
      height="450"
      :src="require('@/assets/images/news/suezmax.jpg')"
    ></v-img>
    <!-- 
      src="@/assets/images/terminals/Oiltanking_Belgium_Antwerp_Gas_Terminal_NV_Image_tanks1_1920px.jpg"
     -->

    <v-container class="text-justify">
      <h1>{{ $t("suezmaxNews.title") }}</h1>
      <p v-html="$t('suezmaxNews.p1')"></p>
      <p v-html="$t('suezmaxNews.p2')"></p>
      <p v-html="$t('suezmaxNews.p3')"></p>
      <p v-html="$t('suezmaxNews.p4')"></p>
      <p v-html="$t('suezmaxNews.p5')"></p>
      <p v-html="$t('suezmaxNews.p6')"></p>
      <p v-html="$t('suezmaxNews.p7')"></p>
      <p v-html="$t('suezmaxNews.p8')"></p>
      <p v-html="$t('suezmaxNews.p9')"></p>
    </v-container>
  </div>
</template>
